import React from 'react';
import {
  Box, Button, Divider, Paper, Stack, TextField, Typography,
} from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';

import { fetchProgressEvidence, addProgressEvidence } from './taskprogress.apis';
import { IProgressEvidence, ITaskProgress } from './taskprogress.models';

import BizFileField from '../core/BizFileField';

type Props = {
  task?: ITaskProgress;
  onChanged?: () => void;
};

type State = {
  rows: IProgressEvidence[];
  //filename: string;
  remarks: string;
  saving: boolean;
};

export default class ProgressEvidencePanel extends React.PureComponent<Props, State> {
  state: State = {
    rows: [],
    //filename: '',
    remarks: '',
    saving: false,
  };

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.task?.rid !== this.props.task?.rid) {
      this.load();
      //this.setState({ filename: '', remarks: '' });
      this.setState({ remarks: '' });
    }
  }

  load = async () => {
    if (!this.props.task?.rid) return;
    const rows = await fetchProgressEvidence(this.props.task.rid);
    this.setState({ rows });
  };

  // addEvidence = async () => {
  //   const { task } = this.props;
  //   const { filename, remarks } = this.state;

  //   if (!task?.rid) return;

  //   this.setState({ saving: true });

  //   await addProgressEvidence({
  //     taskprogressid: task.rid,
  //     evidencetypeid: 1,
  //     fileid: undefined,
  //     records: {},
  //     filename: filename || 'manual-evidence-note.txt',
  //     filedata: {},
  //     attachments: {},
  //     evidencedate: new Date().toISOString().slice(0, 10),
  //     capturerid: 1,
  //     latitude: undefined,
  //     longitude: undefined,
  //     remarks,
  //     extrainfo: {},
  //     status: 1,
  //   });

  //   this.setState({ saving: false, filename: '', remarks: '' });
  //   await this.load();
  //   this.props.onChanged?.();
  // };

  render() {
    const { task } = this.props;
    //const { rows, filename, remarks, saving } = this.state;
    const { rows, remarks, saving } = this.state;

    if (!task) {
      return <Typography color="text.secondary">Select a task to view evidence.</Typography>;
    }

    return (
      <Paper elevation={1} sx={{ p: 2 }}>
        <Typography variant="subtitle1">Evidence</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Attach or review supporting evidence for task execution.
        </Typography>

        <Stack spacing={2}>
          {/* <TextField
            label="Filename"
            size="small"
            value={filename}
            onChange={(e) => this.setState({ filename: e.target.value })}
          /> */}

          <TextField
            label="Remarks"
            multiline
            minRows={2}
            value={remarks}
            onChange={(e) => this.setState({ remarks: e.target.value })}
          />

          <BizFileField
            prefix="EXECUTION"
            service="progressevidence"
            action="add"
            label="Upload Evidence"
            helperText="Upload photos, PDFs, Excel files, or supporting documents."
            accept=".pdf,.jpg,.jpeg,.png,.xlsx,.xls,.csv,.doc,.docx"
            params={{
              tpi: task.rid,
              eti: 1,
              evd: new Date().toISOString().slice(0, 10),
              cpi: 1,
              lat: null,
              lng: null,
              rmk: remarks,
            }}
            onSuccess={async () => {
              this.setState({ remarks: '' });
              await this.load();
              this.props.onChanged?.();
            }}
          />

          {/* <Button
            variant="contained"
            startIcon={<UploadFileIcon />}
            disabled={saving}
            onClick={this.addEvidence}
          >
            Add Evidence
          </Button> */}
        </Stack>
        

        <Divider sx={{ my: 2 }} />

        <Stack spacing={1}>
          {rows.map((r) => (
            <Box key={r.rid}>
              <Typography variant="body2">
                <b>{r.fnm || r.fno || 'Evidence'}</b>
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {r.etn || r.etc} · {r.evd}
              </Typography>
              {r.rmk && (
                <Typography variant="body2" color="text.secondary">
                  {r.rmk}
                </Typography>
              )}
            </Box>
          ))}

          {rows.length === 0 && (
            <Typography variant="body2" color="text.secondary">
              No evidence attached yet.
            </Typography>
          )}
        </Stack>
      </Paper>
    );
  }
}